// extracted by mini-css-extract-plugin
export default {"emoji-picker":"emoji-components_emoji-picker__YRvFF","emoji-comment":"emoji-components_emoji-comment__e6Olo"};